import * as palette from "@govlaunch/palette";
import ProfilePicture from "@govlaunch/profile-picture";
import { Box, CountryFlag, TCountryCode, Tooltip } from "@govlaunch/web";
import Link from "next/link";
import React from "react";
import { ICity, IGovernment } from "~/types/types";
import BudgetIcon from "~/components/icons/BudgetIcon";
import PeopleIcon from "~/components/icons/PeopleIcon";
import GovernmentBudget from "~/components/government/GovernmentBudget";
import GovernmentPopulation from "~/components/government/GovernmentPopulation";

interface IGovernmentRichLink {
  government: Pick<IGovernment, "_id" | "slug" | "isInnovator" | "name" | "logo" | "budget" | "currency"> & {
    city: Pick<ICity, "_id" | "population" | "country" | "countryName">;
  };
  popoverBind?: any;
  popoverInnerRef?: any;
}

export default function GovernmentRichLink({ government, popoverBind, popoverInnerRef }: IGovernmentRichLink) {
  return (
    <Link href="/governments/[governmentSlug]/[[...content]]" as={`/governments/${government.slug}`} passHref={true}>
      <a {...popoverBind}>
        <div
          css={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box position="relative">
            <ProfilePicture
              xsmall={true}
              name={government.name}
              image={government.logo}
              innovator={government.isInnovator}
            />

            <Tooltip
              maxWidth="230px"
              textAlign="center"
              aria-label={government.name}
              label={government.city.countryName}
              bg="blue.600"
              py={2}
            >
              <Box as="span" position="absolute" bottom={1} right={-2}>
                <CountryFlag countryCode={government.city.country as TCountryCode} width={24} height={14} />
              </Box>
            </Tooltip>
          </Box>

          <div
            css={{
              marginLeft: 10,
            }}
          >
            <p
              ref={popoverInnerRef}
              css={{
                margin: 0,
                fontSize: 14,
                color: palette.text,
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
              }}
            >
              {government.name}
            </p>

            <div
              css={{
                display: "grid",
                gridAutoColumns: "max-content",
                gridAutoFlow: "column",
                gridColumnGap: 4,
                alignItems: "center",
              }}
            >
              {government.city.population && (
                <span
                  css={{
                    display: "inline-grid",
                    gridColumnGap: 4,
                    gridTemplateColumns: "max-content max-content",
                    alignItems: "center",
                    color: palette.sealBlue,
                    fontSize: 12,
                  }}
                >
                  <GovernmentPopulation population={government.city.population} />
                  <PeopleIcon width={14} height={10} />
                </span>
              )}

              {!!government.city.population && !!government.budget && (
                <span
                  css={{
                    color: palette.sealBlue,
                    fontSize: 12,
                  }}
                >
                  /
                </span>
              )}

              {!!government.budget && (
                <span
                  css={{
                    display: "inline-grid",
                    gridColumnGap: 4,
                    gridTemplateColumns: "max-content max-content",
                    alignItems: "center",
                    color: palette.sealBlue,
                    fontSize: 12,
                  }}
                >
                  <GovernmentBudget budget={government.budget} currency={government.currency} />
                  <BudgetIcon width={10} height={10} />
                </span>
              )}
            </div>
          </div>
        </div>
      </a>
    </Link>
  );
}
